import { api, resolvePagination } from './api';

/**
 * Retrieve list of clinics.
 * @param {number} pageLimit
 * @param {string} pageToken
 * @param {string} query
 */
export const getClinics = async (pageLimit, pageToken, query) => {
    const headers = resolvePagination(pageToken, pageLimit);

    if (query) {
        return api.post('/cheart/admin/clinics/search', { query }, { headers });
    }

    return api.get('/cheart/admin/clinics', { headers });
};

/**
 * Fetch clinic by uuid
 * @param {string} uuid
 */
export const fetchClinic = async (uuid) =>
    api.post('/cheart/admin/clinics/fetch', {
        uuid
    });

/**
 * Create clinic
 */
export const postClinic = async (values) => {
    const payload = {
        name: values.name,
        email: values.email,
        plan: values.plan,
        features: values.features,
        address: {
            street: values.street,
            zip: values.zip,
            city: values.city,
            province: values.province,
            country: values.country
        }
    };

    return api.post('/cheart/admin/clinics', payload);
};

/**
 * Update clinic
 */
export const patchClinic = async (values) => {
    const payload = {
        uuid: values.uuid,
        name: values.name,
        email: values.email,
        plan: values.plan,
        features: values.features,
        address: {
            street: values.street,
            zip: values.zip,
            city: values.city,
            province: values.province,
            country: values.country
        }
    };

    return api.patch('/cheart/admin/clinics', payload);
};

/**
 * Upload clinic picture
 * @param {string} uuid - clinic uuid
 * @param {File} file - imagem a enviar
 */
export const postClinicPicture = async (uuid, file) => {
    const formData = new FormData();
    formData.append('uuid', uuid);
    formData.append('picture', file);

    return api.post('/cheart/admin/clinic/picture', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};